import script from "./CoachKickstart.vue?vue&type=script&setup=true&lang=js"
export * from "./CoachKickstart.vue?vue&type=script&setup=true&lang=js"

import "./CoachKickstart.vue?vue&type=style&index=0&id=1c7e08ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c7e08ec"]])

export default __exports__